
const digest = '0372df8d8fc44c9188af3bfd4dfbdba30a63afba9d83c15fadd7261597ca51bf';
const classes = {"status":"_status_12urs_1","statusText":"_statusText_12urs_7","checkboxWrapper":"_checkboxWrapper_12urs_12"};
const css = `._status_12urs_1 {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 10px;
}
._status_12urs_1 ._statusText_12urs_7 {
  font-size: 14px;
  font-weight: 500;
}

._checkboxWrapper_12urs_12 {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  